import { render, staticRenderFns } from "./workList.vue?vue&type=template&id=0461227d&"
import script from "./workList.vue?vue&type=script&lang=js&"
export * from "./workList.vue?vue&type=script&lang=js&"
import style0 from "./workList.vue?vue&type=style&index=0&id=0461227d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports